/* eslint-disable no-redeclare */
import { z } from 'zod';

export const SessionId = z.string();

export type SessionId = z.infer<typeof SessionId>;
